//Componentes generales
import React, { useReducer } from "react";
import solicitudesGLBReducer from "./solicitudesGLBReducer";
import solicitudesGLBContext from "./solicitudesGLBContext";
import moment from "moment";

//Axios
import clienteAxios from "../../config/axios";

import { Buffer } from "buffer";

//Rutas de api
import { getFiles, updateSolicitudAjuste } from "../../api/solicitudAjuste";

//Acciones
import {
  CAMBIAR_FROM_SOLICITUD,
  ACTUALIZAR_SOLICITUD,
  NOTIFICACION,
} from "./solicitudesGLBActions";

/* 
    State encargado de la gestión de filtros y listado de solicitudes.
*/
const SolicitudesGLBState = (props) => {
  //Valores iniciales
  const initialState = {
    filtros: {
      state: [],
      fecAlt: {
        desde: new Date(moment(new Date()).subtract(365, "days")),
        hasta: new Date(moment(new Date())),
      },
      userName: [],
    },
    solicitudSelected: {},
    notificacion: "",
    from: "Solicitudes",
  };

  const [state, dispatch] = useReducer(solicitudesGLBReducer, initialState);

  const modificarEstado = async (data, usuario, upd) => {
    try {
      const formData = new FormData();

      formData.append("soliAjusId", JSON.stringify(data._id));
      formData.append("user", JSON.stringify(usuario));
      formData.append("updates", JSON.stringify(upd));
      formData.append("fecMod", JSON.stringify(data.fecMod));

      const resp = await updateSolicitudAjuste(formData);
      dispatch({
        type: ACTUALIZAR_SOLICITUD,
        payload: resp.data.data,
      });
      const solicitudUpdated = resp.data;
      return solicitudUpdated;
    } catch (error) {
      console.log(error);
      /* dispatch({
                type: NOTIFICACION,
                payload: error.response.data.errMsg
            }) */
      throw error;
    }
  };

  const setFrom = (value) => {
    dispatch({
      type: CAMBIAR_FROM_SOLICITUD,
      payload: value,
    });
  };

  const getFilesBySolicitud = async (solicitud) => {
    try {
      const resp = await getFiles(
        solicitud.soliAjusCodFor,
        solicitud.soliAjusNroFor
      );

      return resp.data.data;
    } catch (error) {
      console.log(error);
      return [];
    }
  };

  return (
    <solicitudesGLBContext.Provider
      value={{
        filtros: state.filtros,
        solicitudSelected: state.solicitudSelected,
        notificacion: state.notificacion,
        from: state.from,
        modificarEstado,
        setFrom,
        getFilesBySolicitud,
      }}
    >
      {props.children}
    </solicitudesGLBContext.Provider>
  );
};

export default SolicitudesGLBState;